import React, {Fragment, Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'connected-react-router/immutable';
import 'sweetalert2/dist/sweetalert2.min.css';
import swal from 'sweetalert2/dist/sweetalert2.min';
import ProgressBar from 'progressbar.js';
import {t, Trans} from '@lingui/macro';

import {getCurrentCompany} from '@reducers/companies';
import {getUserCampaign, getUserCampaignList} from '@reducers/userCampaign';
import {isAccountWidgetOpen, getIsMobile} from '@reducers/ui';
import {getUserFullName} from '@reducers/user';
import {logout} from '@actions/login';
import {openAccountWidget, closeAccountWidget} from '@actions/ui';

import {
  HOME,
  REPORT,
  /*HELP, */ TEST,
  TESTS,
  TEST_START,
  CAMPAIGNSELECTOR,
  QUESTIONNAIRE360,
  EVALUATION360,
} from '@services/routes';
import {withQueues} from '@services/context';

import AppBar from '@components/AppBar';
import MainMenu from '@components/MainMenu';
import MainMenuButton from '@components/MainMenuButton';
import AccountWidget from '@components/AccountWidget';
import FlatButton from '@components/FlatButton';
import SkillupLogo from '@components/Icons/SkillupLogo';
import CloseIcon from '@components/Icons/CloseIcon';
import ExitIcon from '@components/Icons/ExitIcon';
import EditIcon from '@components/Icons/EditIcon';

import cl from 'classnames';
import s from './MainHeader.css';

class MainHeader extends Component {
  makeGoTo = path => () => {
    this.props.push(path);
  };

  goToHome = this.makeGoTo(HOME);
  goToReport = this.makeGoTo(REPORT);
  goToTests = this.makeGoTo(TESTS);
  goToCampaignSelector = this.makeGoTo(CAMPAIGNSELECTOR);
  goToSkillup360 = this.makeGoTo(QUESTIONNAIRE360);

  handleOpenAccountWidget = ev => {
    ev.stopPropagation();

    const {openAccountWidget} = this.props;
    openAccountWidget();
  };

  handleCloseAccountWidget = ev => {
    ev.stopPropagation();

    const {closeAccountWidget} = this.props;
    closeAccountWidget();
  };

  handleCloseTest = () => {
    const {match} = this.props;

    if (match.path === EVALUATION360) {
      this.goToSkillup360();
    } else {
      this.goToHome();
    }
  };

  logout = () => {
    const {requestsQueue, logout} = this.props;
    const initialSize = requestsQueue.size();
    if (initialSize > 0) {
      let progress;
      const swalHtml = (
        <Trans render={({translation}) => <p>{translation}</p>} id="header.modal_html">
          Attendi che i dati vengano completamente sincronizzati, il logout verrà effettuato
          automaticamente alla fine.Puoi saltare questo pasaggio ma rischi di perdere il tuo
          progresso non ancora salvato.
        </Trans>
      );

      swal({
        title: <Trans id="modal.synchronization">Sincronizzazione</Trans>,
        html: `${swalHtml}<div id="progress" style="width:400px;height:60px;margin: 0 auto;"></div>`,
        type: 'info',
        showCancelButton: false,
        confirmButtonText: 'Salta',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        onOpen() {
          progress = new ProgressBar.Line('#progress', {
            color: '#FCB03C',
            strokeWidth: 3,
            trailWidth: 1,
            text: {
              value: '0%',
            },
          });
        },
      }).then(result => {
        if (result.value) {
          requestsQueue.turnIntoLogsAndClear();
          logout();
        }
      });
      requestsQueue.options.onProcessing = () => {
        const size = requestsQueue.size();
        const delta = initialSize - size;
        const progressVal = delta / initialSize;
        if (progress) {
          progress.animate(progressVal, {duration: 800});
          progress.setText(Math.round(progressVal * 100) + '%');
        }

        if (size <= 0) {
          // Let the final animation take place
          setTimeout(() => {
            requestsQueue.options.onProcessing = null;
            swal.close();
            logout();
          }, 1000);
        }
      };
    } else {
      logout();
    }
  };

  renderAccountWidget = () => {
    const {
      userFullName,
      awOpen,
      isMobile,
      location: {pathname},
      userCampaignList,
    } = this.props;

    const isTesting =
      pathname === TEST || pathname === QUESTIONNAIRE360 || pathname === EVALUATION360;

    if (isMobile) {
      return isTesting ? (
        <FlatButton className={s.CloseButton} onClick={this.goToHome}>
          <CloseIcon />
        </FlatButton>
      ) : (
        <>
          {userCampaignList &&
            userCampaignList.size > 1 && (
              <FlatButton className={s.Icon} onClick={this.goToCampaignSelector}>
                <EditIcon width={'1.8em'} height={'1.8em'} />
              </FlatButton>
            )}
          <FlatButton className={s.Icon} onClick={this.logout}>
            <ExitIcon width={'1.8em'} height={'1.8em'} />
          </FlatButton>
        </>
      );
    }

    return (
      <AccountWidget
        name={userFullName}
        open={awOpen}
        onClick={awOpen ? this.handleCloseAccountWidget : this.handleOpenAccountWidget}
        avatarSize={isMobile ? 25 : 40}
        showOpenButton={!isTesting}
        showCloseButton={isTesting}
        clickable={!isTesting}
        onClose={isTesting ? this.handleCloseTest : null}
        // onClose={isTesting ? this.goToHome : null}
      >
        {/*<div
          className={cl(s.WidgetButton, s.Profile)}
          onClick={() => console.log('go to profile')}
        >
          <p>Profilo personale</p>
          <AnonymousUserIcon className={cl(s.Icon)} />
        </div>*/}
        {userCampaignList &&
          userCampaignList.size > 1 && (
            <FlatButton
              className={cl(s.WidgetButton, s.Logout)}
              onClick={this.goToCampaignSelector}
            >
              <Trans
                render={({translation}) => <p>{translation}</p>}
                id="header.menu_change_campaign"
              >
                Change Campaign
              </Trans>
              <EditIcon className={cl(s.Icon)} />
            </FlatButton>
          )}

        <FlatButton id="esc-menu" className={cl(s.WidgetButton, s.Logout)} onClick={this.logout}>
          <Trans render={({translation}) => <p>{translation}</p>} id="header.menu_logout">
            Logout
          </Trans>
          <ExitIcon className={cl(s.Icon)} />
        </FlatButton>
      </AccountWidget>
    );
  };

  renderLeftHeader = () => {
    const {company, logo, isMobile} = this.props;

    return (
      <Fragment>
           <SkillupLogo width={isMobile ? '4em' : '5.28em'} />
         {isMobile ? null : logo ? (
          <img
            className={s.Logo}
            src={logo}
            alt={t({id: `header.logo_alt`, message: "Logo dell'azienda"})}
          />
        ) : (
          <div className={s.Company}>{company.get('name')}</div>
        )}
      </Fragment>
    );
  };

  render() {
    const {match, hideMenu, isMobile} = this.props;
    const path = match?.path;

    return (
      <Fragment>
        <AppBar
          className={s.Header}
          leftElements={this.renderLeftHeader()}
          middleElements={
            <div className={s.TaskRoom}>
              <Trans render={({translation}) => <p>{translation}</p>} id="header.title_task_room">
                TASK ROOM
              </Trans>
            </div>
          }
          rightElements={this.renderAccountWidget()}
        />
        {!hideMenu && (path !== TEST_START || !isMobile) ? (
          <AppBar
            className={s.Menu}
            leftElements={
              isMobile ? (
                <MainMenu className={s.NavMobile}>
                  <MainMenuButton
                    text={'Overview'}
                    onClick={this.goToHome}
                    active={path === HOME}
                    to={HOME}
                  />
                  <MainMenuButton
                    text={t({id: `header.menu_tests`, message: 'Tests'})}
                    onClick={this.goToTests}
                    active={path === TESTS}
                    to={TESTS}
                  />
                </MainMenu>
              ) : (
                <MainMenu>
                  <MainMenuButton
                    text={t({
                      id: `header.menu_task_room`,
                      message: 'Task Room',
                    })}
                    onClick={this.goToHome}
                    active={path === HOME}
                    to={HOME}
                  />
                  <MainMenuButton
                    text={t({id: `header.menu_report`, message: 'Report'})}
                    onClick={this.goToReport}
                    active={path === REPORT}
                    to={REPORT}
                  />
                  {/*<MainMenuButton
                      text="Aiuto"
                      onClick={this.goToHelp}
                      active={path === HELP}
                    />*/}
                </MainMenu>
              )
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const userFullName = getUserFullName(state);
  const company = getCurrentCompany(state);
  const userCampaign = getUserCampaign(state);
  const userCampaignList = getUserCampaignList(state);
  const logo = userCampaign.get('logo');
  const awOpen = isAccountWidgetOpen(state);
  const isMobile = getIsMobile(state);

  return {
    userFullName,
    company,
    logo,
    awOpen,
    isMobile,
    userCampaignList,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      push,
      logout,
      openAccountWidget,
      closeAccountWidget,
    },
    dispatch
  );
}

export const ConnectedMainHeader = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    pure: false,
  }
)(withQueues(MainHeader));
